const name = 'corban';
const path = '/corban';

export default [
  // routes
  {
    name: `${name}-screening`,
    path: `${path}/pre-cadastro`,
    component: () => import('@/views/CorbanScreening.vue'),
  },
];
